import {Switcher} from "./js/switcher";
import {Gallery} from "./js/gallery";
import {Tabs} from "./js/tabs";
import {Accordion} from "./js/accordion";
import {ImageSlider} from "./js/imageslider";
import {Parallaxe} from "./js/parallaxe";
import {FormErrors} from "./js/form";
import {Leaflet} from "./js/leaflet";
import {Lightbox} from "./js/lightbox";

const components = {
  '.jsswitcher': Switcher,
  'figure.gallery': Gallery,
  '.tabbed': Tabs,
  '.accordion': Accordion,
  'form': FormErrors,
  '.imageslider': ImageSlider,
  '.has-bg.is-parallaxe': Parallaxe,
  '.leaflet': Leaflet,
  '.lightbox': Lightbox
};

document.addEventListener('DOMContentLoaded', function() {
  Object.keys(components).forEach((selector) => {
    const containers = document.querySelectorAll(selector);
    if (containers.length > 0) {
      [...containers].forEach((item) => {
        new components[selector](item);
      });
    }
  });

});


(function() {
  let header = null;
  let mainmenu = null;

  const observer = new IntersectionObserver((entries, observer) => {
    if (entries.length > 0) {
      if (entries[0].isIntersecting) {
        mainmenu.classList.remove('sticky');
      } else {
        mainmenu.classList.add('sticky');
      }
    }
  }, {
    rootMargin: "30px"
  });

  let menuToggle;
  document.addEventListener('DOMContentLoaded', function() {
    header = document.querySelector("#header");
    mainmenu = document.querySelector("nav.mainmenu");
    observer.observe(header);
    menu();
  });

  function closeMenu(e) {
    if (e.target.tagName === "A") {
      mainmenu.classList.remove('open');
    }
  }

  function menu() {
    menuToggle = document.querySelector('nav.mainmenu .toggler');
    menuToggle.addEventListener('click', toggleMenu);
    mainmenu.addEventListener('click', closeMenu);
  }

  function toggleMenu(e) {
    e.stopPropagation();
    mainmenu.classList.toggle('open');
  }
})();
